import {useLocation, useNavigate} from "react-router-dom";
import React, {useRef, useState} from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import { createPodcast} from "../../actions/NewsPages";

interface FormData {
    title: string;
    subtitle: string;
    image: File | null;
    caption: string;
    content: string;
    content_2?: string;
    podcast: string;
    seo_meta_title: string;
    seo_meta_description: string;
    seo_meta_keywords: string;
    seo_meta_ogimage: File | null;
}

function AddNewPodcast() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [errors, setErrors] = useState<string[]>([]);
    const [successMessage, setSuccessMessage] = useState<string>("");
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const fileInputRef = useRef<HTMLInputElement>(null);

    const [formData, setFormData] = useState<FormData>({
        title: "",
        subtitle: "",
        image: null,
        caption: "",
        content: "",
        content_2: "",
        podcast: "",
        seo_meta_title: "",
        seo_meta_description: "",
        seo_meta_keywords: "",
        seo_meta_ogimage: null,
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0] || null;
            setFormData(prev => ({ ...prev, [name]: file }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleQuillChange = (value: string, name: string) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrors([]);
        setSuccessMessage("");

        try {
            const formDataToSend = new FormData();

            // Append basic form data
            Object.keys(formData).forEach(key => {
                const value = formData[key as keyof FormData];
                if (value !== null && value !== undefined) {
                    if (value instanceof File) {
                        formDataToSend.append(key, value);
                    } else {
                        formDataToSend.append(key, value.toString());
                    }
                }
            });

            // Call the actual API method
            const response = await createPodcast(formDataToSend);

            if (response.data?.success) {
                setSuccessMessage("News podcast created successfully!");
                navigate('/dashboard/podcasts/list', {state: {user}});
                // Optionally: reset form here if needed
                // setFormData(initialFormData);
            } else {
                // Handle possible failure even with 200 OK response
                setErrors([response.data?.message || "An unexpected error occurred"]);
            }

        } catch (error: any) {
            console.error("Error submitting form:", error);
            // If the server returned validation errors:
            if (error.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors).flat();
                console.log(errorMessages);
            } else {
                setErrors(["An error occurred while submitting the form"]);
            }
        }
    };

    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <h2>Add New Podcast</h2>
                <form
                className="form-horizontal form-label-left"
                onSubmit={handleSubmit}
                encType="multipart/form-data"
                style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                >
                    <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                        <div style={{flex: 6, border: '0.5px solid #a5adb5', padding: '10px'}}>
                            <h3>Content</h3>
                            <div className="content-form-field" style={{ marginBottom: '10px' }}>
                                <input
                                    type="text"
                                    className="input-email"
                                    placeholder="Title"
                                    id="title"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">Subtitle</label>
                                    <textarea
                                        value={formData.subtitle}
                                        onChange={handleInputChange}
                                        name="subtitle"
                                        className="form-control news_subtitle"
                                        // placeholder="Subtitle"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label" style={{marginRight: '20px'}}>Image</label> <br/>
                                    <input
                                        type="file"
                                        id="image"
                                        className="form-control news_image"
                                        name="image"
                                        ref={fileInputRef}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <br/>
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">Image Caption</label>
                                    <textarea
                                        value={formData.caption}
                                        onChange={handleInputChange}
                                        name="caption"
                                        className="form-control news_subtitle"
                                        // placeholder="Subtitle"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '0' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">Content</label>
                                    <ReactQuill
                                        value={formData.content}
                                        onChange={(value: string) => handleQuillChange(value, 'content')}
                                        modules={modules}
                                        theme="snow"
                                        style={{ minHeight: '200px' }}
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: '10px' }}>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="control-label">Content 2 (optional)</label>
                                        <ReactQuill
                                            value={formData.content_2}
                                            onChange={(value: string) => handleQuillChange(value, 'content_2')}
                                            modules={modules}
                                            theme="snow"
                                            style={{ minHeight: '200px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group" style={{ marginBottom: '10px' }}>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="control-label">Podcast (iframe)</label>
                                        <textarea
                                            value={formData.podcast}
                                            onChange={handleInputChange}
                                            name="podcast"
                                            className="form-control news_subtitle"
                                            required />
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div style={{flex: 4, border: '0.5px solid #a5adb5', padding: '10px'}}>
                            <h3>SEO</h3>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label" style={{textAlign: 'left'}}>SEO Title</label>
                                    <input
                                        type="text"
                                        className="form-control news_title"
                                        name="seo_meta_title"
                                        value={formData.seo_meta_title}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="eg. Vinimark | Title"
                                    />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">SEO Meta Description</label>
                                    <textarea
                                        value={formData.seo_meta_description}
                                        onChange={handleInputChange}
                                        name="seo_meta_description"
                                        className="form-control news_subtitle"
                                        placeholder="min:50; max:160 characters"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">SEO Meta Keywords</label>
                                    <textarea
                                        value={formData.seo_meta_keywords}
                                        onChange={handleInputChange}
                                        name="seo_meta_keywords"
                                        className="form-control news_subtitle"
                                        placeholder="seperate each keyword with a comma"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12" >
                                    <label className="control-label" style={{marginRight: '20px'}}>Social Media sharing image</label> <br/>
                                    <label className="control-label" style={{marginRight: '20px', fontSize: '12px'}}>max: 2 megabytes; dimensions: 300 x 300px</label><br/> <br/>
                                    <input
                                        type="file"
                                        id="seo_meta_ogimage"
                                        className="form-control news_image"
                                        name="seo_meta_ogimage"
                                        ref={fileInputRef}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <br/>

                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '0' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>



            </div>
        </div>
    );

}

export default AddNewPodcast;
